const RoundButton = (props) => {
  const { title, onClick, icon, style, btnColor = "", iconColor, isLoading = false } = props;

  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      disabled={isLoading}
      className={`btn btn-default bg-${btnColor} btn-circle btn-my`}
      style={{ ...(style ?? { margin: "0px 2px 2px 2px" }), boxShadow: "none" }}
    >
      {isLoading ? (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      ) : (
        <i
          className={`fa fa-${icon ?? "plus"} fa-fw img-circle`}
          style={{ color: iconColor }}
        ></i>
      )}
    </button>
  );
};

export default RoundButton;
